import { render, staticRenderFns } from "./OptionsSelector.vue?vue&type=template&id=71974cbd&"
import script from "./OptionsSelector.vue?vue&type=script&lang=js&"
export * from "./OptionsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports